import React from 'react'

import { Card } from '@mantine/core'

import { spreadableProps } from './domHelpers'

import styles from './CardWrapper.module.css'

// Shared card for a thread or comment
export const CardWrapper = ({
  type,
  children,
  scrollToId,
  onClick,
  selected,
}: {
  type: 'panel-thread' | 'feed-thread' | 'feed-comment'
  scrollToId?: string
  children: React.ReactNode
  onClick?: Callback
  selected?: boolean
}) => {
  const scrollProps = scrollToId
    ? spreadableProps('data-panel-thread', scrollToId)
    : undefined

  return (
    <Card
      classNames={styles}
      data-type={type}
      data-selected={selected || undefined}
      shadow="none"
      px={10}
      pt={10}
      pb={10}
      onClick={onClick}
      {...scrollProps}
    >
      {children}
    </Card>
  )
}
